import { get, post } from "../../../../axios-interceptor-setup/apiService";

export const getIngReportData = (body) => {
  return post(`/smart_city_tcu/ingReport`, { ...body });
};

// ING's own location-filter endpoint isn't live yet, so City/Depot/Contract
// options are sourced from the existing, live TCU locationFilter API
// (same pattern as src/services/cesl-bus/tcuService.js -> getCityDepotContract).
export const getCityDepotContract = (body) => {
  return post(`/smart_city_tcu/locationFilter`, { ...body });
};

export const loggingApiING = () => {
  return post(`/auth/logging`, { page_name: "ING_BUS" });
};
